import src from '../assets/thegreenjacketgolf.png';
import { imageLogo } from './imageLogo';

export const GreenJacketGolfLogo = imageLogo({
  src,
  width: 617,
  height: 404,
  alt: 'The Green Jacket',
});
